import type { Question } from "./quizTypes";

type UiLang = "oz" | "uz" | "ru";

// rawQs (any[]) ni Question[] ga aylantirish
export function mapRawQuestions(
  rawQs: any[],
  lang: UiLang,
  answerMeta: Record<number, { correctAnswerIndex: number }>,
  prevQuestions: Question[] = [],
): Question[] {
  const prevCorrectMap = new Map(
    prevQuestions.map((q) => [q.id, q.correct_answer_index]),
  );

  return rawQs.map((item: any) => {
    const metaCorrect = answerMeta[item.id]?.correctAnswerIndex;

    return {
      id: item.id,
      question: item[`question_${lang}`] || item.question_uz || item.question,
      photo_url: item.photo_url || item.image,
      correct_answer_index:
        metaCorrect ?? prevCorrectMap.get(item.id) ?? item.correct_answer_index,
      choices: (item.choices || item.answers || []).map((c: any) => ({
        id: c.id,
        order_index: c.order_index,
        text: c[`text_${lang}`] || c.text_uz || c.text,
      })),
      explanation:
        item[`explanation_${lang}`] || item.explanation_uz || undefined,
    };
  });
}
